import { render, staticRenderFns } from "./ShopOrderListDialog.vue?vue&type=template&id=09aa02b6&scoped=true&"
import script from "./ShopOrderListDialog.vue?vue&type=script&lang=js&"
export * from "./ShopOrderListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa02b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VCardText,VContainer,VDialog,VDivider,VFlex,VLayout,VSelect,VSpacer,VSubheader,VTextField,VTextarea})
